var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('i'),_c('span',[_vm._v(_vm._s(_vm.text))]),_c('i')])
}
var staticRenderFns = []

export { render, staticRenderFns }